import { IGetterFn } from '@/store/types';

// x轴光源对齐样式
export const xPivotStyleItems: IGetterFn = () => [
  { optionValue: '自由', optionKey: 'Free' },
  { optionValue: '居中', optionKey: 'Center' },
  { optionValue: '右对齐', optionKey: 'Positive' },
  { optionValue: '左对齐', optionKey: 'Negative' },
];

// y轴光源对齐样式
export const yPivotStyleItems: IGetterFn = () => [
{ optionValue: '自由', optionKey: 'Free' },
  { optionValue: '居中', optionKey: 'Center' },
  { optionValue: '前对齐', optionKey: 'Positive' },
  { optionValue: '后对齐', optionKey: 'Negative' },
];

// z轴光源对齐样式
export const zPivotStyleItems: IGetterFn = () => [
  { optionValue: '自由', optionKey: 'Free' },
  { optionValue: '居中', optionKey: 'Center' },
  { optionValue: '顶对齐', optionKey: 'Positive' },
  { optionValue: '底对齐', optionKey: 'Negative' },
];
